class SaleVat {
    constructor(obj){
        if(obj){
            this.id = obj.id;
            this.name= obj.name;
            this.number= obj.number;
            this.vat= obj.vat;
            this.saleOrPurchase= obj.vat;
            this.vatType= obj.vatType;
            this.defaultVat= obj.defaultVat;
        }
        else {
            this.id = 0;
            this.name= "";
            this.number= 0;
            this.vat= null;
            this.saleOrPurchase= 1;
            this.vatType= 0;
            this.defaultVat= null;
        }
    }
}

export default SaleVat;